import React from 'react';
import { Box, Text, Flex, Circle, Pressable, useTheme } from 'native-base';
import { Alert, Platform } from 'react-native';
import { useAuthState } from '../../context/auth';
import { userAPI } from '../../context/user';
import { overviewAPI } from '../../context/overview';
import { useEnvState } from '../../context/env';
import Confirm from '../content/common/reusables/Confirm';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { faMessageDots } from '@fortawesome/pro-regular-svg-icons';
import { LANGUAGES } from '../Constants';
const SearchResultItem = _ref => {
  let {
    user,
    navigation
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const envState = useEnvState();
  const authState = useAuthState();
  const {
    username,
    name,
    avatar_template
  } = user;
  const moderatorColor = colors.searchResultItem.moderator;
  const authUserName = `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`;
  const checkPreviousMessageData = async () => {
    try {
      var _privateMessagesRespo, _privateMessagesRespo2;
      // first check if this user has opted out from receiving DMs (moderators can still send messages)
      const selectedUserData = await userAPI.getUser(envState.base_url, username, authState.api_key);
      if (selectedUserData && selectedUserData.user) {
        const {
          can_send_private_message_to_user: isUserReceivingDM
        } = selectedUserData.user;
        if (!isUserReceivingDM) {
          if (Platform.OS === 'web') {
            Confirm.success('Oh no...', LANGUAGES.USER_HAS_OPTED_OUT);
          } else {
            Alert.alert('Oh no...', LANGUAGES.USER_HAS_OPTED_OUT);
          }
          return null;
        }
      }

      // then check if any previous direct message data exists
      const privateMessagesResponse = await overviewAPI.getPrivateMessagesSent(envState.base_url, authUserName, authState.api_key);
      const privateMessagesSent = privateMessagesResponse === null || privateMessagesResponse === void 0 ? void 0 : (_privateMessagesRespo = privateMessagesResponse.topic_list) === null || _privateMessagesRespo === void 0 ? void 0 : _privateMessagesRespo.topics;
      let usersList = (privateMessagesResponse === null || privateMessagesResponse === void 0 ? void 0 : (_privateMessagesRespo2 = privateMessagesResponse.users) === null || _privateMessagesRespo2 === void 0 ? void 0 : _privateMessagesRespo2.filter(user => user.username != authUserName)) || [];
      const interactedUsernames = usersList.map(user => user.username);
      /*
      for potential use
      const interactedUserIDs = usersList.map((u) => u.id);
      const interactedNames = usersList.map((u) => u.name);
      */

      if (!interactedUsernames.includes(username)) {
        navigation.navigate('PrivateMessage', {
          username,
          name
        });
      } else {
        const selectedUser = usersList.filter(user => user.username === username)[0];
        const selectedUserID = selectedUser === null || selectedUser === void 0 ? void 0 : selectedUser.id;
        const existingMessage = privateMessagesSent.filter(topic => topic.participants.length > 0).filter(filteredTopic => filteredTopic.participants.find(participant => participant.user_id === selectedUserID))[0];
        navigation.navigate('PrivateMessage', {
          topicId: existingMessage.id,
          username,
          name
        });
      }
      return privateMessagesResponse;
    } catch (err) {
      console.log('Error while checking messages data');
      return err;
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    my: 1,
    px: 4
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Circle, {
    size: 7,
    bg: colors.searchResultItem.circle.user
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUser,
    color: colors.searchResultItem.icon
  })), /*#__PURE__*/React.createElement(Text, {
    color: user.moderator ? moderatorColor : '#000',
    fontWeight: 'bold'
  }, name), /*#__PURE__*/React.createElement(Text, null, username), /*#__PURE__*/React.createElement(Pressable, {
    onPress: checkPreviousMessageData
  }, /*#__PURE__*/React.createElement(Circle, {
    size: 7,
    bg: colors.searchResultItem.circle.dots
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faMessageDots,
    color: colors.searchResultItem.icon
  })))));
};
export default SearchResultItem;
//# sourceMappingURL=SearchResultItem.js.map